import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { TooltipContainerStyled } from "../styled/TooltipContainerStyled";
/**
 * This component is mostly for presentation, and is exposed to our consumers in case they want to
 * use these styles in their own components. Generally, that has taken the form of a custom Flyout
 * so it can have interactive elements inside of it.
 */
export const TooltipContainer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    squareCorner = undefined,
    ...rest
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(TooltipContainerStyled, _extends({}, rest, {
    squareCorner: squareCorner,
    themeMode: themeMode,
    ref: ref
  }), children);
});
TooltipContainer.displayName = "TooltipContainer";
//# sourceMappingURL=TooltipContainer.js.map